import { render, staticRenderFns } from "./OtelGo.vue?vue&type=template&id=4775ff43&scoped=true"
import script from "./OtelGo.vue?vue&type=script&lang=js"
export * from "./OtelGo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4775ff43",
  null
  
)

export default component.exports